// src/components/common/FallingLeaves.js
import React, { useMemo } from "react";

export default function FallingLeaves() {
  const leaves = useMemo(
    () =>
      Array.from({ length: 15 }).map((_, i) => {
        const style = {
          left: `${Math.random() * 100}vw`,
          animationDelay: `${Math.random() * 10}s`,
          animationDuration: `${5 + Math.random() * 5}s`,
        };
        return <div key={i} className="leaf" style={style}></div>;
      }),
    []
  );
  return (
    <div className="fixed inset-0 w-full h-full pointer-events-none z-50">
      {leaves}
    </div>
  );
}
